<template>
  <div>
    <template>
      <div class="receipt" style="font-family: '微软雅黑';">
        <div class="page" id='external-scriptInfo-others'>
          <!-- 处方信息 -->
          <div style="font-size: 8pt; line-height: 16pt;height: 16pt;">
            <p style="float: left;">NO.{{ record.inquiryInfo.recordId }}</p>
            <div style="float: right;">
              <p style="display: inline-block;float: right;">
                <span tdata="pageNO" format="#">##</span>/<span tdata="pageCount" format="#">##</span>
              </p>
              <p
                  style="width: 25pt;float: right; text-align:center;height: 14pt;line-height: 12pt;border:1pt solid rgba(51,51,51,1);border-radius: 3pt;display: inline-block;margin-right: 8pt;">
                普通</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <h3 style="text-align: center; font-size: 16pt;margin-top: 0pt;">{{ printConfig.titleName
          || $store.state.global.countInfo.hospitalName }}
          </h3>
          <h4 style="text-align: center; font-size: 12pt;margin-top: -13pt;">{{ !title ? "外治处方" : '外治处方（' + title.slice(0, 2) + '）' }}</h4>
          <div class="user-info" style="margin-top: -10pt;font-size: 9pt;font-family: '微软雅黑';">

            <div style="border-bottom: 1pt solid #999; line-height: 20pt;height: 20pt;">
              <div style="display: inline-block;width: 33.333%; float: left;">
                姓名：{{ record.patient.patientName }}&nbsp;&nbsp;
                {{ record.patient.gender == -1 ? '未知' : (record.patient.gender == 0 ? '女' : '男') }}&nbsp;&nbsp;
                <span v-if="record.inquiryInfo.clinicalAge">{{ record.inquiryInfo.clinicalAge }}</span>
                <span v-else>
                  <span v-if="record.patient.year > 0">{{ record.patient.year }}岁</span>
                  <span v-if="record.patient.month > 0 && record.patient.year >= 0 && record.patient.year < 5">{{
                      record.patient.month }}月</span>
                  <span v-if="record.patient.year === 0 && record.patient.day > 0">{{ record.patient.day }}天</span>
                </span>
              </div>

              <div style="display: inline-block;width: 33.333%; float: left;">
                <!--诊号：{{ record.inquiryInfo.recordId }}-->
                诊号：{{ record.inquiryInfo.recordId ? record.inquiryInfo.recordId : getTimeStamp() }}
              </div>

              <div style="display: inline-block;width: 33.333%; float: left;">
                就诊日期：{{ record.inquiryInfo.clinicalTime }}
              </div>
            </div>

            <div style="line-height: 20pt;height: 20pt;">
              <div style="display: inline-block;width: 33.333%; float: left;">
                科室：{{ record.inquiryInfo.laboratoryName }}
              </div>

              <div style="display: inline-block;width: 33.333%; float: left;">
                费别：{{ record.inquiryInfo.hiMedType |  medTypeFilter }}
              </div>

              <div style="display: inline-block;width: 33.333%; float: left;">
                手机号：{{ record.patient.phoneNo }}
              </div>
            </div>

            <div style="border-bottom: 1pt solid #999;line-height: 20pt;">
              <div>
                临床诊断：{{ record.inquiryInfo.diagnosisResultString }}
              </div>
            </div>
          </div>

          <div style="clear: both;"></div>
          <div style="margin-bottom: 4pt;line-height: 20pt;">Rp.</div>
        </div>

        <!-- 列表 -->
        <div class="page" id="external-idAdd-others">
          <!--<div style="margin-bottom: 4pt;line-height: 20pt;">Rp.</div>-->
          <!--<div style="clear: both;"></div>-->
          <table border=0 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size: 10pt;font-family: '微软雅黑';">
            <tbody>
            <template v-for="(item, index) in record.patientStickingList">
              <tr :key="index" style="display: block;">
                <template v-for="(item2, index2) in item.patientStickingDrugGroupNewList">
                  <div :key="index2">
                    <!-- 标题 -->
                    <template v-for="(drugNameItem, drugNameIndex) in item2.patientStickingDrugList">
                      <div :key="drugNameIndex" style="font-size: 12pt;font-family: '微软雅黑';height: 20pt;line-height: 20pt">
                        {{ 1 + index2 + '.' +  drugNameItem.drugName }}
                      </div>
                    </template>

                    <!-- 贴敷,现配 -->
                    <template v-if="item.category === 9 && item.subCategory === 2">
                      <div style="display: flex;align-items: center; margin-top: 2pt;">
                        <div style="flex: 1;display: flex;display: flex">
                          <template v-for="(configDrugItem, configDrugItemIndex) in item2.patientStickingConfigDrugList">
                            <div :key="configDrugItemIndex">
                              {{ configDrugItem.drugName }}&nbsp;&nbsp;{{ configDrugItem.dosage }}{{ configDrugItem.dosageUnit }}
                              <span v-if="configDrugItemIndex !== item2.patientStickingConfigDrugList.length-1">、</span>
                            </div>
                          </template>
                        </div>
                      </div>
                    </template>

                    <!-- 穴位 -->
                    <div style="display: flex;align-items: center; margin-top: 2pt;">
                      <div style="width: 10.5%;">穴位：</div>
                      <div style="flex: 1;display: flex;font-size: 10pt;display: flex">
                        <template v-for="(acupointItem, acupointItemIndex) in item2.templatePatientStickingAcupointFormList">
                          <div :key="acupointItemIndex">
                            [{{ acupointItem.remark }}]{{ acupointItem.headName }}
                            <span v-if="acupointItemIndex !== item2.templatePatientStickingAcupointFormList.length-1">、</span>
                          </div>
                        </template>


                      </div>
                    </div>

                    <!-- 统计 -->
                    <div style="display: flex; justify-content:center;align-items: center; margin-top: 2pt;">
                      <div style="width: 10.5%;">用法：</div>
                      <div style="font-size: 10pt;flex: 1">
                        共&nbsp;&nbsp;{{ item2.num }}&nbsp;&nbsp;次,&nbsp;&nbsp;{{ item2.frequency }}&nbsp;&nbsp;,每次&nbsp;&nbsp;
                        {{ item2.everyNum }}&nbsp;&nbsp;<span>{{ item2.category === 9 ? "贴": "穴" }}</span>,
                        共&nbsp;&nbsp;{{ item2.totalNum }}&nbsp;&nbsp;<span>{{ item2.category === 9 ? "贴": "穴" }}</span>&nbsp;&nbsp;
                      </div>

                      <div v-for="(item2, index2) in item.patientStickingDrugGroupNewList" >
                        <div v-if="(item2.remark)" style="font-size: 8pt" >
                          (备注:
                          <span >{{item2.remark }}</span>
                          )
                        </div>
                      </div>
                      &nbsp;&nbsp; &nbsp;&nbsp;
                      <div style="font-size: 10pt;">小计:￥{{ item2.totalAmount }}</div>
                    </div>
                  </div>
                </template>
              </tr>
              <div style="margin-top: 6pt;border-bottom: 1pt dashed #ccc;width: 100%;"></div>
            </template>
            </tbody>
          </table>
        </div>

        <!-- 诊所信息 -->
        <div style="margin-top: 0pt;font-size: 9pt;font-family: '微软雅黑';" id="external-footer-info-others">
          <div style="font-size: 9pt;border-bottom: 1pt solid #999; line-height: 24pt;height:24pt;">
            <div style="float: right; width: 49%;text-align: center;">
              <!--{{ prescriptionAmt }}-->
              金额：￥<span id="externalTotalSum">{{ getExternalSumPrice }}</span>
            </div>
            <div style="clear: both"></div>
            <div style="width: 25.00%; float: left;">
              医生：<span v-if="printConfig.printDoctorName == 1">{{ record.realName }}</span>
              <!-- 医生：<span>{{record.realName}}</span> -->
            </div>

            <div style="width: 25.00%; float: left;">
              审核：
            </div>

            <div style="width: 25.00%; float: left;">
              调配：
            </div>

            <div style="width: 25.00%; float: left;">
              核发：
            </div>
          </div>
          <div style="clear: both;"></div>
          <p style="font-size: 9pt;margin-top: 4pt;">除主治医师特别注明外，处方仅当日有效，按卫生部规定，药品一经发出，不得退换</p>
          <!--<p style="font-size: 9pt;margin-top: 4pt;font-family: '微软雅黑';">打印时间：{{ printTime }}</p>-->
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import moment from 'moment';
import { getLodop } from '@/plugins/LodopFuncs.js';
import { BigNumber } from 'bignumber.js';
import { medTypeFilter } from "@/utils/util";

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  /**
   *  type 的几种类型
   *  medicine -> 成药
   *  pieces -> 饮片
   *  infusion -> 输液
   *  apply -> 服帖
   *  infusionCard -> 输液卡
   *  other -> 其他
   *  externalPrint -> 外治处方打印
   */
  name: "externalPrint",
  props: {
    record: {
      type: Object,
      default: {
        patient: {
          patientName: ''
        },
      },
    },
    isReview: {
      type: Boolean,
      default: false,
    },
    // 是否分页
    diagnosisProjectPrint: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      printConfig: {
        printDoctorName: 0, // 是否打印名字
        printTotalPrice: 0, // 是否显示价格
        remark: 0, // 打印备注
      },
      printTime: '',
      curType: 'other',
      title: "",//标题,
      copyRecord: {},//备份传递的数据
    }
  },
  computed: {
    // 计算外治处方总金额
    getExternalSumPrice() {
      if (!this.record.patientStickingList) return;
      const arr = [];
      this.record.patientStickingList.forEach(item => {
        item.patientStickingDrugGroupNewList.forEach(data => {
          arr.push(data);
        });
      });
      return arr.reduce((cur, pre) => (cur + pre.totalAmount), 0);
    },
  },
  watch: {
    record() {
      this.copyRecord = JSON.parse(JSON.stringify(this.record));
    }
  },
  mounted() {
    this.getPrintConfig();//获取打印配置
  },
  methods: {
    // 打印设置
    // { name = "", index = -1, title =  "", type =  -1 } = {}
    /**
     *  print 参数
     *  isReview -> 是否显示
     *  typeIndex -> 索引
     *  title -> 标题
     *  itemType -> 类型id
     *  key -> 取值key
     */
    print({ isReview, typeIndex = -1, title, itemType, key } = {}) {
      console.log("外治处方打印", key, typeIndex, title, itemType, "数组=", this.record)
      this.title = title;
      this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      const { otherValue } = this.$store.state.global.printConfig;

      // this.record.patientStickingList = this.record.patientStickingList.filter(item => item.category === itemType);
      if (itemType) {
        this.record.patientStickingList = this.copyRecord.patientStickingList.filter(item => item.category === itemType);
      } else {
        this.record.patientStickingList = this.copyRecord.patientStickingList;
      }

      this.$nextTick(() => {
        const LODOP = getLodop();
        LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
        LODOP.PRINT_INIT('其他处方打印');
        LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', '其他处方打印');
        LODOP.ADD_PRINT_HTM(0, '5%', '90%', '50mm', document.getElementById('external-scriptInfo-others').innerHTML);
        LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
        LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
        LODOP.ADD_PRINT_HTM('58mm', '5%', '90%', '110mm', document.getElementById('external-idAdd-others').innerHTML);
        // LODOP.ADD_PRINT_HTM('170mm', '5%', '90%', '50mm', document.getElementById('external-footer-info-others').innerHTML);
        LODOP.ADD_PRINT_HTM('165mm', '5%', '90%', '50mm', document.getElementById('external-footer-info-others').innerHTML);
        LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
        LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
        LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
        LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); //打印后自动关闭预览窗口
        LODOP.SET_PRINTER_INDEX(otherValue);
        // LODOP.SET_PRINTER_INDEX(0);
        // LODOP.PREVIEW();
        // if (isReview) {
        LODOP.PREVIEW();
        // } else {
        //   LODOP.PRINT();
        // }
      });
    },
    // 获取时间戳
    getTimeStamp() {
      const time = "" + new Date().getTime();
      return time.substring(0, 7);
    },
    // 获取打印配置
    getPrintConfig() {
      this.$api.clinicManagement.getPrintConfit({ configType: 6 }).then((res) => {
        this.printConfig = res;
      })
    }
  },
  filters: {
    medTypeFilter
  },
}
</script>
<style lang="scss" scoped>
.header-info {
  border-bottom: 2pt solid #000000;
}

.receipt {
  width: 300pt;
  justify-content: space-between;
}

span {
  display: inline-block;
  width: 20pt;
  height: 20pt;
  background: #AAAAAA;
}

.receipt {
  position: fixed;
  border: 1pt solid #000000;
  z-index: 100;
  width: 1000pt;
  left: 100pt;
  background: white;
  left: -5000pt;
  top: 100pt;
}
</style>
